import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Отправьте вещь на Трансфер", -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Вещь отфотографирована", -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoveMaster = _resolveComponent("MoveMaster")!

  return (_ctx.isToTransfer)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_MoveMaster, {
          "prop-options": { type: 'h-h', source: 2, destination: 1 },
          "url-set": "/storage/moving-photozone-transfer",
          "data-set": { id: _ctx.product?.id },
          onSuccessMoveMaster: _ctx.success,
          onNextMoveMaster: _ctx.next
        }, null, 8, ["data-set", "onSuccessMoveMaster", "onNextMoveMaster"])
      ]))
    : (
			[_ctx.enumProductState.shooted, _ctx.enumProductState.published, _ctx.enumProductState.unavailable].includes(
				_ctx.product?.state || -1
			)
		)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
      : _createCommentVNode("", true)
}